var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle125(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "267.22526919263225 102.07949498488227 14.256953029589965 15.827513211839644",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M277.47,110.48c-.01.2-.03.49-.05.78-.07,1.04-.21,2.07-1.38,2.46-1.18.39-2.29.17-3.23-.66-1.03-.91-1.51-2.12-1.58-3.46-.1-1.82,1.4-3.49,3.11-3.52,1.55-.03,2.93,1.28,3.12,3.02.05.43,0,.87,0,1.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle125);
export default __webpack_public_path__ + "static/media/twinkle-1-25.b696684c48e42fe4c66bbe2609980c21.svg";
export { ForwardRef as ReactComponent };